import { render, staticRenderFns } from "./dialog-avg-on-time.vue?vue&type=template&id=0a4c8d1c&"
import script from "./dialog-avg-on-time.vue?vue&type=script&lang=js&"
export * from "./dialog-avg-on-time.vue?vue&type=script&lang=js&"
import style0 from "./dialog-avg-on-time.vue?vue&type=style&index=0&id=0a4c8d1c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports